import {
  Box,
  Button,
  Fade,
  FormControl,
  Image,
  Input,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Img } from "../../../content/Content";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa6";
import { AiOutlineClose } from "react-icons/ai";
import "./Header.component.css";
function Header() {
  const [searchOpen, setSearch] = useState(false);
  const [langDrop, setLangDrop] = useState(false);
  const [profile, setProfile] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  const Lang = [
    {
      name: "English",
      flag: Img.us,
    },
    {
      name: "English (uk)",
      flag: Img.uk,
    },
    {
      name: "France ",
      flag: Img.france,
    },
    {
      name: "Germany",
      flag: Img.germany,
    },
  ];
  return (
    <VStack
      bg="rgba(23, 25, 25, 1)"
      h="94px"
      position={"fixed"}
      top={"0"}
      left={"0"}
      right={"0"}
      zIndex={"87777"}
    >
      {/* Header */}
      <Box w="80%" margin={"auto"} className="desktop-version">
        <VStack maxW={"100%"} w={"100%"} flexDir={"row"} alignItems={"center"}>
          {/* Logo */}
          <Stack w="20%">
            <Link to="/">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
              >
                <Image src={Img.logoWhite} alt="logo" />
                <Text
                  color={"rgba(255, 53, 53, 1)"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                  position="relative"
                  top="-20px"
                >
                  LIVE
                </Text>
              </Box>
            </Link>
          </Stack>

          {/* menu bar */}
          <Stack w="80%" justifyContent={"end"} position={"relative"}>
            <Box
              display={"flex"}
              justifyContent={"flex-end"}
              alignItems="center"
            >
              {/* Search- bar */}
              <Stack>
                <FormControl
                  position={"relative"}
                  display="flex"
                  alignItems="center"
                  margin="0 10px"
                >
                  <Fade in={searchOpen}>
                    <Input
                      type="text"
                      bg="transparent"
                      border={
                        searchOpen
                          ? "1.5px solid rgba(149, 151, 171, 1)"
                          : "none"
                      }
                      borderRadius="25px"
                      padding={searchOpen ? "12px 40px" : "0"}
                      color="#fff"
                      w={searchOpen ? "200px" : "0"}
                      onClick={() => setSearch(!searchOpen)}
                    />
                  </Fade>
                  <Image
                    src={Img.search}
                    alt="search"
                    position={searchOpen ? "absolute" : ""}
                    left="10px"
                    top="10px"
                    cursor="pointer"
                    onClick={() => setSearch(!searchOpen)}
                  />
                </FormControl>
              </Stack>

              {/* language bar */}
              <Stack position="relative" w="115px">
                <Box
                  marginTop={"10px"}
                  display="flex"
                  alignItems="center"
                  cursor="pointer"
                  justifyContent="center"
                  onClick={() => setLangDrop(!langDrop)}
                >
                  <Image
                    src={Img.us}
                    alt="photo"
                    w="28px"
                    h="28px"
                    borderRadius="25"
                  />
                  <Text
                    fontSize="14px"
                    fontWeight="400"
                    margin="0 6px"
                    color="#fff"
                  >
                    English
                  </Text>
                </Box>
                <Fade in={langDrop}>
                  <Box
                    h="auto"
                    top="44px"
                    position="absolute"
                    left={"0"}
                    borderRadius="15px"
                    bg="white"
                  >
                    <UnorderedList
                      padding="0"
                      margin="0"
                      listStyleType="none"
                      display="flex"
                      alignItems="flex-start"
                      justifyContent={"center"}
                      flexDir="column"
                    >
                      {Lang.map((items) => {
                        return (
                          <ListItem padding="10px 10px" margin={"5px 0"}>
                            <Box
                              display="flex"
                              alignItems="center"
                              cursor="pointer"
                              w="100%"
                            >
                              <Image
                                src={items.flag}
                                alt="photo"
                                w="28px"
                                h="28px"
                                borderRadius="25"
                              />
                              <Text
                                fontSize="14px"
                                fontWeight="400"
                                margin="0 6px"
                                color="#000"
                              >
                                {items.name}
                              </Text>
                            </Box>
                          </ListItem>
                        );
                      })}
                    </UnorderedList>
                  </Box>
                </Fade>
              </Stack>
              {/* Notification */}
              <Stack>
                <Box padding={"0 8px"}>
                  <Image src={Img.notification} />
                </Box>
              </Stack>
              <Stack>
                <Box
                  padding={"0 8px"}
                  cursor={"pointer"}
                  onClick={() => setProfile(!profile)}
                >
                  <Image src={Img.profile} />
                </Box>
              </Stack>
              {profile ? (
                <Box
                  position="absolute"
                  top="70px"
                  borderRadius="10px"
                  bg={"#EDF2F7"}
                  py="15px"
                >
                  <Button w="100%">Profile</Button>
                  <Button w="100%">Setting</Button>
                  <Button w="100%">Logout</Button>
                </Box>
              ) : (
                ""
              )}
            </Box>
          </Stack>
        </VStack>
      </Box>
      {/* mobile-header */}
      <Box w="80%" margin={"auto"} className="mobile-version">
        <VStack maxW={"100%"} w={"100%"} flexDir={"row"} alignItems={"center"}>
          {/* Logo */}
          <Stack w="20%">
            <Link to="/">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
              >
                <Image src={Img.logoWhite} alt="logo" />
                <Text
                  color={"rgba(255, 53, 53, 1)"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                  position="relative"
                  top="-20px"
                >
                  LIVE
                </Text>
              </Box>
            </Link>
          </Stack>

          {/* menu bar */}
          <Stack
            w="80%"
            flexDirection="row"
            justifyContent={"end"}
            position={"relative"}
          >
            <Button
              onClick={() => setMobileMenu(!mobileMenu)}
              color={"#fff"}
              bg="transparent"
              _hover={{ bg: "transparent" }}
              display="inline-block"
            >
              {mobileMenu ? <AiOutlineClose /> : <FaBars />}
            </Button>
          </Stack>
          {mobileMenu ? (
            <Box
              display={"flex"}
              justifyContent={"flex-end"}
              alignItems="center"
              flexDir="column"
              position="absolute"
              top="93px"
              w="100%"
              height="100vh"
              left="0"
              bg={"#000000d6"}
              pt="0"
            >
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems="center"
                flexDir="column"
                position="absolute"
                top="40px"
              >
                {/* Search- bar */}
                <Stack my="10px">
                  <FormControl
                    position={"relative"}
                    display="flex"
                    alignItems="center"
                    margin="0 10px"
                  >
                    <Fade in={searchOpen}>
                      <Input
                        type="text"
                        bg="transparent"
                        border={
                          "1.5px solid rgba(149, 151, 171, 1)"
                        }
                        borderRadius="25px"
                        padding={"12px 40px"}
                        color="#fff"
                        w={'100%'}
                      />
                    </Fade>
                    <Image
                      src={Img.search}
                      alt="search"
                      position={searchOpen ? "absolute" : ""}
                      left="10px"
                      top="10px"
                      cursor="pointer"
                      onClick={() => setSearch(!searchOpen)}
                    />
                  </FormControl>
                </Stack>

                {/* language bar */}
                <Stack position="relative" w="115px" my="10px">
                  <Box
                    marginTop={"10px"}
                    display="flex"
                    alignItems="center"
                    cursor="pointer"
                    justifyContent="center"
                    onClick={() => setLangDrop(!langDrop)}
                  >
                    <Image
                      src={Img.us}
                      alt="photo"
                      w="40px"
                      h="40px"
                      borderRadius="25"
                    />
                    <Text
                      fontSize="20px"
                      fontWeight="400"
                      margin="0 6px"
                      color="#fff"
                    >
                      English
                    </Text>
                  </Box>
                  <Fade in={langDrop}>
                    <Box
                      h="auto"
                      top="67px"
                      left="-41px"
                      position="absolute"
                      borderRadius="15px"
                      bg="white"
                      width="200px"
                      zIndex="555555"
                    >
                      <UnorderedList
                        padding="0"
                        margin="0"
                        listStyleType="none"
                        display="flex"
                        alignItems="center"
                        justifyContent={"center"}
                        flexDir="column"
                      >
                        {Lang.map((items) => {
                          return (
                            <ListItem padding="10px 10px" margin={"5px 0"}>
                              <Box
                                display="flex"
                                alignItems="center"
                                cursor="pointer"
                                w="100%"
                              >
                                <Image
                                  src={items.flag}
                                  alt="photo"
                                  w="40px"
                                  h="40px"
                                  borderRadius="25"
                                />
                                <Text
                                  fontSize="14px"
                                  fontWeight="400"
                                  margin="0 6px"
                                  color="#000"
                                >
                                  {items.name}
                                </Text>
                              </Box>
                            </ListItem>
                          );
                        })}
                      </UnorderedList>
                    </Box>
                  </Fade>
                </Stack>
                {/* Notification */}
                <Stack my="10px">
                  <Box padding={"0 8px"}>
                    <Image src={Img.notification} w="40" h="40px" />
                  </Box>
                </Stack>
                <Stack my="10px" position={"relative"} zIndex="111">
                  <Box
                    padding={"0 8px"}
                    cursor={"pointer"}
                    onClick={() => setProfile(!profile)}
                  >
                    <Image src={Img.profile} w="40" h="40px" />
                  </Box>
                </Stack>
                {profile ? (
                  <Box
                    position="absolute"
                    top="251px"
                    borderRadius="10px"
                    bg={"#EDF2F7"}
                    py="15px"
                    zIndex={"111111"}
                  >
                    <Button w="100%">Profile</Button>
                    <Button w="100%">Setting</Button>
                    <Button w="100%">Logout</Button>
                  </Box>
                ) : (
                  ""
                )}
              </Box>
            </Box>
          ) : (
            ""
          )}
        </VStack>
      </Box>
    </VStack>
  );
}

export default Header;
